import { createSlice } from "@reduxjs/toolkit";
import { AddCurrency, UpdateCurrency, GetCurrencyList } from "services/other/currency.service";
import { toast } from 'react-toastify';

export const currencyAddSlice = createSlice({
  name: "currencyAdd",
  initialState: {
    currencyAdd: {},
    currencyAddLoading: false,
    currencyAddError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(AddCurrency.pending, (state) => {
      // toast.loading('We are adding the ssd 🤯')
      state.currencyAddLoading = true
    });

    builder.addCase(AddCurrency.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('New ssd added successfully 👌');

      state.currencyAdd = action.payload
      state.currencyAddLoading = false
      state.currencyAddError = null
    });

    builder.addCase(AddCurrency.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the currency 😣")

      state.currencyAddLoading = false
      state.currencyAddError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});

export const currencyUpdateSlice = createSlice({
  name: "currencyUpdate",
  initialState: {
    currencyUpdate: {},
    currencyUpdateLoading: false,
    currencyUpdateError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(UpdateCurrency.pending, (state) => {
      // toast.loading('We are updating the currency 🤯')
      state.currencyUpdateLoading = true
    });

    builder.addCase(UpdateCurrency.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Category update successfully 👌');

      state.currencyUpdate = action.payload
      state.currencyUpdateLoading = false
      state.currencyUpdateError = null
    });

    builder.addCase(UpdateCurrency.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't update the currency 😣")

      state.currencyUpdateLoading = false
      state.currencyUpdateError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});



export const currencyListSlice = createSlice({
  name: "currencyList",
  initialState: {
    currencyList: [],
    currencyListLoading: false,
    currencyListError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetCurrencyList.pending, (state) => {
      state.currencyListLoading = true
    });

    builder.addCase(GetCurrencyList.fulfilled, (state, action) => {
      toast.dismiss();

      state.currencyList = action.payload
      state.currencyListLoading = false
      state.currencyListError = null
    });

    builder.addCase(GetCurrencyList.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the currency 😣")

      state.currencyListLoading = false
      state.currencyListError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});